// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import './assets/fonts/font.css'
import '@/styles/index.less'
import '@icon-park/vue/styles/index.css'
import preview from 'vue-photo-preview'
// iconPack样式文件
import 'vue-photo-preview/dist/skin.css'
import getSensitiveWordFn from '@/utils/getSensitiveWord'
import PopoverCom from '@/components/PopoverCom/index.vue'
Vue.use(preview)
//必须引入的核心
import Recorder from 'recorder-core'
//引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
// import 'recorder-core/src/engine/mp3'
// import 'recorder-core/src/engine/mp3-engine'
//录制wav格式的用这一句就行
import 'recorder-core/src/engine/wav'

//可选的插件支持项，这个是波形可视化插件
import 'recorder-core/src/extensions/wavesurfer.view'

// video插件
import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
import VideoPlayModel from '@/components/VideoPlayModel'
// VideoPlayModel 参数  showVideoModal:是否显示 videoUrl: 视频url  previewType:类型  video image //默认video可以不传

Vue.component('video-play-model', VideoPlayModel)
import PageHeaderCom from '@/components/PageHeaderCom'
Vue.component('popover-com', PopoverCom)
Vue.component('page-header-com', PageHeaderCom)

//ts import 提示：npm包内已自带了.d.ts声明文件（不过是any类型）

// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock' //hxn

import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control======hxn
import './utils/filter' // global filter
import './global.less' // global style
import '@icon-park/vue/styles/index.css'
import STitle from '@/components/STitle/index.vue'
import SButton from '@/components/SButton/index.vue'

Vue.config.productionTip = false

// mount axios to `Vue.$http` and `this.$http`
// Vue.use(VueAxios)//hxn--
Vue.use(VueAxios, router)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('STitle', STitle)
Vue.component('SButton', SButton)
window.umi_plugin_ant_themeVar = themePluginConfig.theme

Vue.prototype.$getSensitiveWordFn = getSensitiveWordFn
Vue.prototype.$sseUrl = process.env.NODE_ENV === 'development' ? `http://${window.document.location.host}/sseapi` : ''
Vue.prototype.$websocketUrl =
  process.env.NODE_ENV === 'development' ? `wss://test.meta-avatory.com` : process.env.VUE_APP_API_BASE_URL_WEBSOCKET

/*import { detectZoom  } from '@/utils/util'
 const m = detectZoom();
if (window.screen.width * window.devicePixelRatio >=3840) {
  document.body.style.zoom = 100 / (Number(m)/2);
}else{
  document.body.style.zoom = 100 / Number(m);
} */

new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex, Logo message
  created: bootstrap,
  render: (h) => h(App),
}).$mount('#app')
